import { Box, Icon } from '@nimbus-ds/components';
import { InfoCircleIcon } from '@nimbus-ds/icons';
import { Text } from '@tiendanube/components';
import useTranslationPayments from 'domains/Payments/useTranslationPayments';

function PercentageOffDiscountAlert(): JSX.Element {
  const t = useTranslationPayments();

  return (
    <Box display="flex" gap="1" alignItems="center">
      <Icon color="danger-textHigh" source={<InfoCircleIcon size={14} />} />
      <Text appearance="danger">
        {t('paymentProvider.settings.hasPercentageOffDiscount')}
      </Text>
    </Box>
  );
}

export default PercentageOffDiscountAlert;
